import "./CreateFile.scss";
import { ArrowSquareLeft, WarningIcon, Filter, OutlineElement2, Settings4, ArrowDown2, OutlineArrowUp2 } from "../../Icon";
import { closeSnackbar, useSnackbar } from "notistack";
import { EGButton } from "../../MainComponents/Button/EGButton/EGButton";
import { EGFlagMessage } from "../../MainComponents/FlagMessage/EGFlagMessage";
import { FormReportTemplate } from "../ReportTemplates/FormReportTemplate";
import { Loading } from "../../Loading/String/Loading";
import { MCButton } from "../../MainComponents/Button/Button";
import { MCLabel, MCSelect } from "../../MainComponents";
import { Modal, Row } from "react-bootstrap";
import { SelectionFields } from "../SelectionFields/SelectionFields";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import EGAutocomplete from "../../MainComponents/Autocomplete/EGAutocomplete";
import EGDateRange from "../../MainComponents/DateRange/EGDateRange";
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import useUnsavedChangesWarning from "../../../hooks/useUnsavedChangesWarning";
import { AdvancedSearch } from "../../Report/Lists/Filter/AdvancedSearch/AdvanceSearch";
import { StatusFilter } from "./StatusFilter";
import {
  listReportTemplates,
  retrieveReportTemplate,
  createExcelExport,
} from "../../../apis/apiExports";

const FormCreateFile = ({
  listOfReportTemplates,
  stateCloseModal,
  stateShowTemplatesForm = null,
  kindFile,
  setKindFile,
  modalSuccessFunction,
}) => {
  const [t] = useTranslation("exports");
  const { enqueueSnackbar } = useSnackbar();

  // List languajes
  const listLanguajes = [
    { value: "es", label: t("createFile.spanish") },
    { value: "en", label: t("createFile.english") },
  ];

  // list report templates states
  const [listReportTemplates, setListReportTemplates] = useState([]);

  // API states
  const [aliasReportTemplate, setAliasReportTemplate] = useState(null);
  const [languajeReportTemplate, setLanguajeReportTemplate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [comment, setComment] = useState(null);
  const [swapDayMonth, setSwapDayMonth] = useState(false);
  // Solo involucrados de investigación (kindFile === 'involved'). El backend ignora
  // este flag en los tenants de MercadoLibre, que ya usan el folder de la
  // investigación como fuente autoritativa.
  const [onlyInvestigationInvolved, setOnlyInvestigationInvolved] = useState(false);
  const [detailReportTemplate, setDetailReportTemplate] = useState([]);

  // Validations states
  const [isValidStartDate, setIsValidStartDate] = useState(true);
  const [isValidEndDate, setIsValidEndDate] = useState(true);

  // loading states
  const [isLoading, setIsLoading] = useState(true);

  // Show Detail Report Template
  const [showDetailReportTemplate, setShowDetailReportTemplate] = useState(false);

  // excel columns
  const [excelColumns, setExcelColumns] = useState({});

  // catalogs filter (only used for kindFile === 'report')
  const [catalogSearch, setCatalogSearch] = useState([]);

  // status filter (used for kindFile === 'report' and 'involved')
  const [statusesFilter, setStatusesFilter] = useState([]);
  const [closedTypesFilter, setClosedTypesFilter] = useState([]);

  // advanced customization panel (columns + filters)
  const [showCustomization, setShowCustomization] = useState(false);
  const [activeTab, setActiveTab] = useState('columns');

  // generating excel
  const [generateModalMessage, setGenerateModalMessage] = useState('');
  const [hasEncryptedFields, setHasEncryptedFields] = useState(false);
  const [isGeneratingExcel, setIsGeneratingExcel] = useState(false);
  const [validationError, setValidationError] = useState('');
  const [validationsInfo, setValidationsInfo] = useState(null);

  const today = dayjs();

  const transformDataToSelect = (data) => {
    /**
         * @param {Array} data
         * "data": [
                {
                    "alias": "RT2f2903RKc18r9da4n9M181Z0512U08Q3",
                    "template_name": "Plantilla del reporte 2 GLOBAL",
                    "created_at": "2023-09-11T10:49:51.840802",
                    "updated_at": "2023-09-11T10:49:51.840836",
                    "is_global": true
                },
                ...
            ]
            * @returns {Array} listReportTemplates
            * "listReportTemplates": [
                {
                    "value": "RT2f2903RKc18r9da4n9M181Z0512U08Q3",
                    "label": "Plantilla del reporte 2 (Global)"
                },
                ...
            ]
         */
    setListReportTemplates(
      data.map((item) => {
        return {
          value: item.alias,
          label: item.is_global
            ? `${item.template_name} (Global)`
            : item.template_name,
        };
      })
    );
  };

  const getDetailDataReportTemplate = async (alias) => {
    const { data } = await retrieveReportTemplate(alias);
    if (data !== undefined || data !== null) {
      const { template_fields } = data;
      setIsLoading(false);
      setDetailReportTemplate(template_fields);
    }
  };

  const handleSelectionChange = ({ listElement }) => {
    setIsLoading(true);
    setAliasReportTemplate(listElement.value);
    setShowDetailReportTemplate(true);
    getDetailDataReportTemplate(listElement.value);
  };

  const handleSelectedLanguage = ({ listElement }) => {
    setLanguajeReportTemplate(listElement.value);
  };

  const formatDate = (date) => {
    const dateWithoutFormat = new Date(date);
    const year = dateWithoutFormat.getFullYear();
    const month = dateWithoutFormat.getMonth() + 1;
    const day = dateWithoutFormat.getDate();
    return `${year}-${month}-${day}`;
  };

  const handleDates = ({ startDay, endDay, minDay, maxDay, error }) => {
    if (error) {
      setIsValidStartDate(false);
      setIsValidEndDate(false);
      setValidationError(error);
      return;
    }
    setValidationError('');

    if (startDay && endDay) {
      if (startDay.isValid()) {
        setIsValidStartDate(true);
        setStartDate(startDay.toDate());
      }
      if (endDay.isValid()) {
        setIsValidEndDate(true);
        setEndDate(endDay.toDate());
      }
    }
  };

  const handleComment = (e) => {
    const comment = e.target.value.trim();
    if (comment !== "") setComment(comment);
    else setComment(null);
  };

  const columnKeys = Object.keys(excelColumns);
  const groupedKeys = [];
  
  for (let i = 0; i < columnKeys.length; i += 2) {
    groupedKeys.push(columnKeys.slice(i, i + 2));
  }

  // Save Data
  const handleSaveData = async () => {
    setValidationError('');
    setGenerateModalMessage(t("createFile.generating_report"));
    setIsGeneratingExcel(true);

    const snackBarSending = enqueueSnackbar(t("createFile.saving_data"), {
      variant: "info",
      persist: true,
    });

    const data = {
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
    };

    if (kindFile === 'report') {
      data['template_alias'] = aliasReportTemplate
      data['excel_columns'] = excelColumns
      data['catalogs_filter'] = catalogSearch
      data['statuses_filter'] = {
        statuses: statusesFilter,
        closed_types: closedTypesFilter,
      }
    }

    if (kindFile === 'involved') {
      data['catalogs_filter'] = catalogSearch
      data['statuses_filter'] = {
        statuses: statusesFilter,
        closed_types: closedTypesFilter,
      }
      data['only_investigation_involved'] = onlyInvestigationInvolved;
    }

    if (comment !== null) data.comment = comment;

    if (swapDayMonth) data.swap_day_month = true;

    const response = await createExcelExport(data, languajeReportTemplate, kindFile);

    if (response.message === 'reports not found') {
      setGenerateModalMessage('')
      setValidationError(t("createFile.reports_not_found"))
      closeSnackbar(snackBarSending);
      enqueueSnackbar(t("createFile.reports_not_found"), {
        variant: "error",
      });
      setIsGeneratingExcel(false);
      return;
    }
    
    if (response !== undefined || response !== null) {
      modalSuccessFunction();
      stateCloseModal(false);
      closeSnackbar(snackBarSending);
      enqueueSnackbar(t("createFile.data_saved"), {
        variant: "success",
      });
    }
  };

  const setSelectedColumnsInvestigation = ({ selectedFields, mode }) => {
    let keys = [];
    const columns = {};

    if (mode === 'report') {
      keys = ['entryway', 'dates', 'involved', 'intervals']
    }
    
    keys.forEach((key) => {
      columns[key] = selectedFields.includes(key);
    });
  
    setExcelColumns(columns);
    return;
  };

  const kindOptions = [
    {value: 'report', label: t('createFile.kind_report')},
    {value: 'involved', label: t('createFile.kind_involved')},
    // {value: 'investigation', label: 'Investigación'},
  ];

  const returnOption = (text, action) => {
    return (
      <h5 className="selected-kind-title"><ArrowSquareLeft onClick={action} />{text}<span></span></h5>
    );
  };

  const InfoBox = () => {
    return (
      <>
        <EGFlagMessage
          exists={true}
          type={validationsInfo?.theme || 'info'}
          message={validationsInfo?.content || ''}
          loading={validationsInfo?.state === 'generating'}
        />
      </>
    );
  };  

  const getCustomDate = (code = null, days = 1000) => {
    if (code && localStorage.getItem(code)) {
      return dayjs(localStorage.getItem(code)).format("DD/MM/YYYY");
    }
    return today.subtract(days, "day").format("DD/MM/YYYY");
  };

  const getMinDate = (date1, date2) => {
    if (!dayjs(date1, "DD/MM/YYYY", true).isValid()) return date2;
    if (!dayjs(date2, "DD/MM/YYYY", true).isValid()) return date1;
  
    const parsedDate1 = dayjs(date1, "DD/MM/YYYY");
    const parsedDate2 = dayjs(date2, "DD/MM/YYYY");
  
    return parsedDate1.isBefore(parsedDate2) ? date1 : date2;
  };

  useEffect(() => {
    setValidationsInfo({
      state: 'info',
      theme: 'success',
      content: returnOption(t(`createFile.selected_${kindFile}_mode`), () => setKindFile('')),
    })
    transformDataToSelect(listOfReportTemplates);
  }, []);

  useEffect(() => {
    setHasEncryptedFields(false);
    if (detailReportTemplate?.some(item => item.is_sensitive)) {
      setHasEncryptedFields(true);
    }
    
  }, [detailReportTemplate]);

  useEffect(() => {
    setValidationsInfo({
      state: 'info',
      theme: 'success',
      content: returnOption(t(`createFile.selected_${kindFile}_mode`), () => setKindFile('')),
    });
    setCatalogSearch([]);
    setStatusesFilter([]);
    setClosedTypesFilter([]);
    setShowCustomization(false);
    setActiveTab('columns');
  }, [kindFile]);

  useEffect(() => {
    if (isGeneratingExcel) {
      setValidationsInfo({
        state: 'generating',
        theme: 'info',
        content: generateModalMessage,
      });
      return;
    }

    setValidationsInfo({
      state: 'info',
      theme: 'success',
      content: returnOption(t(`createFile.selected_${kindFile}_mode`), () => setKindFile('')),
    });
  }, [isGeneratingExcel]);

  useEffect(() => {
    if (validationError) {
      setValidationsInfo({
        state: 'error',
        theme: 'danger',
        content: returnOption(validationError, () => setKindFile('')),
      });
      return;
    }

    setValidationsInfo({
      state: 'info',
      theme: 'success',
      content: returnOption(t(`createFile.selected_${kindFile}_mode`), () => setKindFile('')),
    });
  }, [validationError]);

  return (
    <>
      {
        kindFile === '' ? (
          <>
            <Row className="mt-2">
              <MCLabel text={t("createFile.select_kind_1")} isRequired />
              <MCSelect
                label={t("createFile.report_template")}
                options={kindOptions}
                onChange={(event) => setKindFile(event.value)}
              />
            </Row>
          </>
        ) : (
          <>
            <Row className="mt-2">
              <InfoBox />
            </Row>
            {
              (
                kindFile === 'report'
              ) && (
                <Row className="mt-2">
                  <Grid sx={{ padding: '0' }} container spacing={2}>
                    <Grid size={{ xs: 12, md: 9 }}>
                      <EGAutocomplete
                        label={t("createFile.select_template_label")}
                        // initialValue="Option 1"
                        options={listReportTemplates}
                        callback={handleSelectionChange}
                        tag="exportables-template"
                        errorMessage=""
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                      <EGButton
                        label={t("createFile.new_template")}
                        variant="outlined"
                        color="primary"
                        fullWidth
                        onClick={() => stateShowTemplatesForm(true)}
                      />
                    </Grid>
                  </Grid>
                </Row>
              )
            }
            {
              (
                kindFile === 'report' || kindFile === 'involved' || kindFile === 'investigation'
              ) && (
                <Row className="mt-2">
                  <EGDateRange
                    startLabel={t("createFile.start_date_label")}
                    endLabel={t("createFile.end_date_label")}
                    startDate={getCustomDate(null, 10)}
                    endDate={today.format("DD/MM/YYYY")}
                    // minDate={getMinDate(getCustomDate('first_created_at'), getCustomDate(null, 10))} // TODO check validation
                    
                    // maxDate={today.format("DD/MM/YYYY")} // TODO check validation
                    
                    callback={handleDates}
                    errorMessage={t("createFile.dates_not_valid_error")}
                  />
                </Row>
              )
            }
            {
              (
                kindFile === 'report'
              ) && (
                <Row className="mt-2">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={swapDayMonth}
                        onChange={(e) => setSwapDayMonth(e.target.checked)}
                      />
                    }
                    label={t("createFile.swap_day_month_label")}
                  />
                </Row>
              )
            }
            {
              (
                kindFile === 'involved'
              ) && (
                <Row className="mt-2">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={onlyInvestigationInvolved}
                        onChange={(e) => setOnlyInvestigationInvolved(e.target.checked)}
                      />
                    }
                    label={t("createFile.only_investigation_involved_label")}
                  />
                  <p className="customization-tabpanel__helper">
                    {t("createFile.only_investigation_involved_helper")}
                  </p>
                </Row>
              )
            }
            {
              (
                kindFile === 'report' || kindFile === 'involved' || kindFile === 'investigation'
              ) && (
                <Row className="mt-2">
                    <EGAutocomplete
                      label={`${t("createFile.select_language")} (${t(
                        "createFile.optional"
                      )}):`}
                      // initialValue="Option 1"
                      options={listLanguajes}
                      callback={handleSelectedLanguage}
                      tag="exportables-language"
                      errorMessage=""
                    />
                </Row>
              )
            }
            {
              (
                kindFile === 'investigation'
              ) && (
                <>
                  <Row className="mt-2">
                    <SelectionFields
                      label={t("createFile.fixed_columns") + ':'}
                      initialValues={[ 'related', 'general', 'scenarios', 'causes', 'dates', 'resources', 'users', 'involved', 'plans', 'interviews' ]}
                      listValues={
                        {
                          related: { label: t("createFile.field_related"), tooltip: 'tooltip value', information: 'information' },
                          general: { label: t("createFile.field_general"), tooltip: 'tooltip value', information: 'information' },
                          scenarios: { label: t("createFile.field_scenarios"), tooltip: 'tooltip value', information: 'information' },
                          causes: { label: t("createFile.field_causes"), tooltip: 'tooltip value', information: 'information' },
                          dates: { label: t("createFile.field_dates"), tooltip: 'tooltip value', information: 'information' },
                          resources: { label: t("createFile.field_resources"), tooltip: 'tooltip value', information: 'information' },
                          users: { label: t("createFile.field_users"), tooltip: 'tooltip value', information: 'information' },
                          involved: { label: t("createFile.field_involved"), tooltip: 'tooltip value', information: 'information' },
                          plans: { label: t("createFile.field_plans"), tooltip: 'tooltip value', information: 'information' },
                          interviews: { label: t("createFile.field_interviews"), tooltip: 'tooltip value', information: 'information' },
                        }
                      }
                      mode="investigation"
                      callbackFields={setSelectedColumnsInvestigation}
                      texts={{
                        selectAll: t("createFile.select_all"),
                        deselectAll: t("createFile.deselect_all"),
                        seeSelected: t("createFile.see_selected"),
                        backSelection: t("createFile.back_selection"),
                        selectValue: t("createFile.select_column_placeholder"),
                        seeSelectedFields: t("createFile.selected_columns_title"),
                        noFields: t("createFile.no_fields_selected"),
                      }}
                      itemsContainerHeight="160px"
                    />
                  </Row>
                </>
              )
            } 
            {
              (
                kindFile === 'report' || kindFile === 'involved'
              ) && (
                <Row className="mt-3">
                  <div className="customization-panel">
                    <button
                      type="button"
                      className={`customization-toggle ${showCustomization ? 'is-open' : ''}`}
                      onClick={() => setShowCustomization((prev) => !prev)}
                      aria-expanded={showCustomization}
                    >
                      <span className="customization-toggle__left">
                        <Settings4 className="customization-toggle__icon" />
                        <span className="customization-toggle__labels">
                          <span className="customization-toggle__title">
                            {showCustomization
                              ? t("createFile.hide_customization")
                              : kindFile === 'report'
                                ? t("createFile.customize_button")
                                : t("createFile.customize_filters_button")}
                          </span>
                          <span className="customization-toggle__helper">
                            {kindFile === 'report'
                              ? t("createFile.customization_helper")
                              : t("createFile.customization_filters_helper")}
                          </span>
                        </span>
                      </span>
                      <span className="customization-toggle__chevron">
                        {showCustomization ? <OutlineArrowUp2 /> : <ArrowDown2 />}
                      </span>
                    </button>

                    <Collapse in={showCustomization} timeout={250}>
                      <div className="customization-content">
                        {kindFile === 'report' && (
                          <>
                            <Tabs
                              value={activeTab}
                              onChange={(_, value) => setActiveTab(value)}
                              variant="fullWidth"
                              className="customization-tabs"
                              TabIndicatorProps={{ className: 'customization-tabs__indicator' }}
                            >
                              <Tab
                                value="columns"
                                disableRipple
                                icon={<OutlineElement2 className="customization-tab__icon" />}
                                iconPosition="start"
                                label={t("createFile.columns_tab")}
                                className="customization-tab"
                              />
                              <Tab
                                value="filters"
                                disableRipple
                                icon={<Filter className="customization-tab__icon" />}
                                iconPosition="start"
                                label={t("createFile.filters_tab")}
                                className="customization-tab"
                              />
                            </Tabs>

                            <Box className="customization-tabpanel" role="tabpanel" hidden={activeTab !== 'columns'}>
                              <SelectionFields
                                style={{ marginBottom: '0' }}
                                label={t("createFile.fixed_columns") + ':'}
                                initialValues={[ 'entryway', 'involved', 'intervals', 'dates' ]}
                                listValues={
                                  {
                                    entryway: { label: t("createFile.entryway"), tooltip: t("createFile.entryway_tooltip"), information: t("createFile.fixed_information") },
                                    dates: { label: t("createFile.dates"), tooltip: t("createFile.dates_tooltip"), information: t("createFile.fixed_information") },
                                    involved: { label: t("createFile.involved"), tooltip: t("createFile.involved_tooltip"), information: t("createFile.fixed_information") },
                                    intervals: { label: t("createFile.intervals"), tooltip: t("createFile.intervals_tooltip"), information: t("createFile.fixed_information") },
                                  }
                                }
                                mode="report"
                                callbackFields={setSelectedColumnsInvestigation}
                                texts={{
                                  selectAll: t("createFile.select_all"),
                                  deselectAll: t("createFile.deselect_all"),
                                  seeSelected: t("createFile.see_selected"),
                                  backSelection: t("createFile.back_selection"),
                                  selectValue: t("createFile.select_column_placeholder"),
                                  seeSelectedFields: t("createFile.selected_columns_title"),
                                  noFields: t("createFile.no_fields_selected"),
                                }}
                                showSeeSelectedButton={false}
                                showAutocomplete={false}
                                showSelectionButtons={false}
                                margin="4px 0 0 0"
                              />
                            </Box>

                            <Box className="customization-tabpanel" role="tabpanel" hidden={activeTab !== 'filters'}>
                              {showCustomization && (
                                <StatusFilter
                                  statuses={statusesFilter}
                                  setStatuses={setStatusesFilter}
                                  closedTypes={closedTypesFilter}
                                  setClosedTypes={setClosedTypesFilter}
                                />
                              )}
                              <p className="customization-tabpanel__helper">
                                {t("createFile.filters_helper")}
                              </p>
                              {showCustomization && (
                                <AdvancedSearch
                                  catalogSearch={catalogSearch}
                                  setCatalogSearch={setCatalogSearch}
                                  isResettingCatalog={false}
                                  itemSize={{ xs: 12, sm: 6 }}
                                />
                              )}
                            </Box>
                          </>
                        )}

                        {kindFile === 'involved' && (
                          <Box className="customization-tabpanel customization-tabpanel--standalone" role="tabpanel">
                            {showCustomization && (
                              <StatusFilter
                                statuses={statusesFilter}
                                setStatuses={setStatusesFilter}
                                closedTypes={closedTypesFilter}
                                setClosedTypes={setClosedTypesFilter}
                              />
                            )}
                            <p className="customization-tabpanel__helper">
                              {t("createFile.filters_helper")}
                            </p>
                            {showCustomization && (
                              <AdvancedSearch
                                catalogSearch={catalogSearch}
                                setCatalogSearch={setCatalogSearch}
                                isResettingCatalog={false}
                                itemSize={{ xs: 12, sm: 6 }}
                              />
                            )}
                          </Box>
                        )}
                      </div>
                    </Collapse>
                  </div>
                </Row>
              )
            }
            {
              (
                kindFile === 'report' || kindFile === 'involved' || kindFile === 'investigation'
              ) && (
                <Row className="mt-2">
                  <TextField
                    label={`${t("createFile.comment")} (${t("createFile.optional")}):`}
                    multiline
                    rows={2}
                    variant="outlined"
                    fullWidth
                    onChange={handleComment}
                  />
                </Row>
              )
            }
            {
              (
                kindFile === 'report'
              ) && (
                <Row className="mt-4">
                  <EGButton
                    label={t("createFile.create_report")}
                    variant="outlined"
                    color="primary"
                    fullWidth
                    disabled={
                      aliasReportTemplate === null ||
                      isValidStartDate === null ||
                      isValidStartDate === false ||
                      isValidEndDate === null ||
                      isValidEndDate === false ||
                      isGeneratingExcel
                    }
                    onClick={handleSaveData}
                  />
                </Row>
              )
            }
            {
              (
                kindFile === 'involved' || kindFile === 'investigation'
              ) && (
                <Row className="mt-4">
                  <MCButton
                    label={t("createFile.create_report")}
                    outline
                    variant="primary"
                    disabled={
                      isValidStartDate === null ||
                      isValidStartDate === false ||
                      isValidEndDate === null ||
                      isValidEndDate === false ||
                      isGeneratingExcel
                    }
                    onClick={handleSaveData}
                  />
                </Row>
              )
            }
            {
              (
                kindFile === 'report'
              ) && (
                <Row className="mt-4">
                  {showDetailReportTemplate &&
                    (!isLoading ? (
                      <>
                        <EGFlagMessage
                          exists={hasEncryptedFields}
                          type={'warning'}
                          header={<><WarningIcon /> {t("createFile.template_warning_header")}</>}
                          message={t("createFile.template_warning")}
                        />
                      </>
                    ) : (
                      <Loading className="mt-3" />
                    ))}
                </Row>
              )
            }
          </>
        )
      }
    </>
  );
};

export const CreateFile = ({ stateCloseModal, modalSuccessFunction, kindFile, setKindFile }) => {
  // API states
  const [areThereReportTemplates, setAreThereReportTemplates] = useState(false);
  const [listOfReportTemplates, setListOfReportTemplates] = useState([]);

  // Loading states
  const [isLoading, setIsLoading] = useState(true);

  // Show Report Template Form
  const [showReportTemplateForm, setShowReportTemplateForm] = useState(false);

  const getListReportTemplates = async () => {
    setIsLoading(true);
    const { data } = await listReportTemplates();
    if (data !== undefined && data.length > 0) {
      setListOfReportTemplates(data);
      setAreThereReportTemplates(true);
    } else setAreThereReportTemplates(false);

    setIsLoading(false);
  };

  useEffect(() => {
    getListReportTemplates();
  }, []);

  useEffect(() => {
    if (!showReportTemplateForm) getListReportTemplates();
  }, [showReportTemplateForm]);

  return (
    <>
      {!isLoading ? (
        areThereReportTemplates ? (
          !showReportTemplateForm ? (
            <FormCreateFile
              listOfReportTemplates={listOfReportTemplates}
              stateShowTemplatesForm={setShowReportTemplateForm}
              stateCloseModal={stateCloseModal}
              kindFile={kindFile}
              setKindFile={setKindFile}
              modalSuccessFunction={modalSuccessFunction}
            />
          ) : (
            <FormReportTemplate
              areThereReportForms={areThereReportTemplates}
              stateToReturn={setShowReportTemplateForm}
            />
          )
        ) : (
          <FormReportTemplate stateToReturn={setAreThereReportTemplates} />
        )
      ) : (
        <Loading />
      )}
    </>
  );
};

export const CreateFileModal = ({ showComponent, stateComponent, modalSuccessFunction }) => {
  const [t] = useTranslation("exports");
  const [kindFile, setKindFile] = useState('');
  useUnsavedChangesWarning(showComponent);

  return (
    <Modal dialogClassName={kindFile === '' ? 'modal-visible' : 'modal-auto'} show={showComponent} centered onHide={stateComponent} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{`${t("createFile.create_file")}`}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <CreateFile
          stateCloseModal={stateComponent}
          modalSuccessFunction={modalSuccessFunction}
          kindFile={kindFile}
          setKindFile={setKindFile}
        />
      </Modal.Body>
    </Modal>
  );
};